import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

const module = angular.module('wind-coverage-contact-me-card', []);

interface WindCoverageContactMeCardController extends angular.IStrictController {
    icon: string;
    description: string;
    reason: ContactReason;
}

module.component('windCoverageContactMeCard', {
    template: template,
    controller: function(this: WindCoverageContactMeCardController) {
        'ngInject';

        this.$onInit = () => {
            this.icon = 'wind';
            this.description = 'Add wind coverage';
            this.reason = 'wind-coverage';
        };
    }
});

export { module };
